export default "__VITE_ASSET__KSjvQYAI__"